import {
  getTotalCartPrice,
  getTotalCartQuantity,
} from '../../../features/cart/cartSlice';
import { getUserIsAuthenticated } from '../../../features/auth/authSlice';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CartDropdownItems from './CartDropdownItems';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CustomButton, YellowButton } from '../../../utils/Button';
import { LoggedInUserDropdown } from './LoggedInUserDropdown';
import { formatCurrency } from '../../../utils/FormatCurrency';
import {
  ChevronDown,
  ChevronUp,
  Heart,
  Info,
  ShoppingCart,
} from 'lucide-react';
import { getUserFirstName } from '../../../features/user/userSlice';
import { useQuery } from '@tanstack/react-query';
import { fetchFavouriteProducts } from '../../../api/product-api';
import DownloadApp from '../../../utils/DownloadApp';

export const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loggedInUserDropdown, setLoggedInUserDropdown] = useState(false);
  const userFullName = useSelector(getUserFirstName);
  const isAuthenticated = useSelector(getUserIsAuthenticated);
  const totalProductsInCart = useSelector(getTotalCartQuantity);

  const { data: favourites = [], isLoading } = useQuery({
    queryKey: ['favourites'],
    queryFn: fetchFavouriteProducts,
  });

  // Filter favourites to only in-stock products once
  const inStockFavourites = favourites.filter(
    (product) => product.inStock !== 'true' || product.inStock !== '1'
  );

  const totalFavouritesProduct = inStockFavourites.length;

  const hanldeCartDropdownItems = () => {
    setIsOpen(!isOpen);
  };

  const handleUserAuthDropdown = (e) => {
    e.stopPropagation();
    setLoggedInUserDropdown((prev) => !prev);
  };

  return (
    <nav aria-label="Main navigation" className="font-duplet font-medium">
      <ul className="flex items-center space-x-6">
        <li className="lg:hidden xl:flex items-center space-x-1 font-medium text-[#333]">
          <DownloadApp />
        </li>
        {!isAuthenticated ? (
          <>
            <li className="font-medium text-[#333]">
              <Link
                to="/sign-up"
                aria-label="Create a new account"
                className="text-[#737376] hover:text-black focus:text-black focus:outline-none focus:ring-2 focus:ring-black transition-colors motion-safe:duration-200 hover:underline"
              >
                Sign up
              </Link>
            </li>
            <li className="font-medium text-[#333]">
              <Link
                to="/login"
                aria-label="Log in to your account"
                className="text-[#737376] hover:text-black  focus:text-black focus:outline-none focus:ring-2 focus:ring-black transition-colors motion-safe:duration-200 hover:underline"
              >
                Log in
              </Link>
            </li>
          </>
        ) : (
          <div className="relative">
            <li
              className="font-medium flex items-center space-x-1 cursor-pointer whitespace-nowrap"
              role="button"
              onClick={handleUserAuthDropdown}
            >
              <span className="text-[#737376]">Hi,</span>
              <span>
                {userFullName.charAt(0).toUpperCase() +
                  userFullName.slice(1).toLowerCase()}
                !
              </span>

              {loggedInUserDropdown ? (
                <ChevronUp size={20} />
              ) : (
                <ChevronDown size={20} />
              )}
            </li>
            {loggedInUserDropdown && (
              <LoggedInUserDropdown
                loggedInUserDropdown={loggedInUserDropdown}
                setLoggedInUserDropdown={setLoggedInUserDropdown}
              />
            )}
          </div>
        )}
        <li aria-hidden="true">
          <hr className="mx-2 h-[22px] w-[1.5px] bg-[#DEDEDE]" />
        </li>
        <li className="lg:hidden xl:flex relative group">
          <button
            className="bg-[#F6F6F6] px-4 py-2 rounded-full font-medium flex items-center space-x-1 hover:bg-gray-200 active:bg-gray-300 focus:ring-2 focus:ring-[var(--yellow-primary)] transition-all motion-safe:duration-200 active:scale-95 cursor-not-allowed"
            aria-label="Purchase a gift card"
            disabled
          >
            <img
              src="/images/gift.svg"
              alt="icon"
              width={24}
              height={24}
              loading="lazy"
              className="transition-transform hover:rotate-12 motion-safe:duration-200"
            />
            <span className="whitespace-nowrap">Get a gift card</span>
          </button>

          {/* Tooltip */}
          <div className="absolute left-1/2 -translate-x-1/2 -top-5 bg-[#FFDE11]  text-sm px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            <span>Coming soon</span>
            <div className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-[#FFDE11] rotate-45"></div>
          </div>
        </li>

        <li className="relative">
          {totalFavouritesProduct > 0 && (
            <div className="bg-[#FB0202] text-white text-[11px] font-medium p-1 rounded-full absolute bottom-[10px] left-3 min-w-6 flex justify-center">
              {totalFavouritesProduct}
            </div>
          )}
          <Link
            to="/user-dashboard/shopping-overview/favorites"
            aria-label="View favorite items"
          >
            <Heart size={24} aria-hidden="true" />
          </Link>
        </li>
        <li>
          <div className="relative" onClick={hanldeCartDropdownItems}>
            {totalProductsInCart > 0 && (
              <div className="bg-[#FB0202] text-white text-[11px] font-medium p-1 rounded-full absolute bottom-[14px] left-3 min-w-6 flex justify-center">
                {totalProductsInCart}
              </div>
            )}
            <button aria-label="View shopping cart">
              <ShoppingCart size={26} aria-hidden="true" />
            </button>
          </div>

          <div className="absolute right-2 top-[4.02rem] w-[412px]">
            <CartDropdownItems isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
        </li>
        <li>
          {/* <CustomButton text="Sell" width="100%" borderRadius="40px" /> */}
        </li>
      </ul>
    </nav>
  );
};
